import { useAppSseClient } from "@/hooks/appSseClientHook";
import { ANALYTICS_BITE_UPDATED } from "@/constants/appSSEEventTypes";

export type AnalyticsBiteUpdatedPayload = {
  sessionId: string;
  slideIdx: number;
};

type AnalyticsStreamHandlers = {
  onAnalyticsBiteUpdated?: (payload: AnalyticsBiteUpdatedPayload) => void;
  /** Fired when the SSE connection (re)opens, including the first connect.
   *  The dashboard uses it to re-read everything, because events published
   *  while the connection was down are gone — SSE has no replay. */
  onOpen?: () => void;
};

export function useAnalyticsEventStream(
  enabled: boolean,
  handlers: AnalyticsStreamHandlers,
): void {
  // No useMemo: useAppSseClient keeps handlers in a ref and only reconnects on
  // `enabled`, so a fresh object each render costs nothing.
  useAppSseClient(
    enabled,
    {
      [ANALYTICS_BITE_UPDATED]: (data) =>
        handlers.onAnalyticsBiteUpdated?.(data as AnalyticsBiteUpdatedPayload),
    },
    { onOpen: handlers.onOpen },
  );
}
